// extracted by mini-css-extract-plugin
module.exports = {"arrow":"index-module_arrow_2vUot","categoryText":"index-module_categoryText_3KA9g"};